import { useQueue } from "./hook";
import { queueMutations } from "./mutations";
import { queueQueries } from "./queries";

export const queueService = {
  query: queueQueries,
  mutation: queueMutations,
  useQueue
};
